import Vue from 'vue'
import Vuex from 'vuex'
import screen_global from './modules/screen_global'
// import speech_recognition from './modules/speech_recognition'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    screen_global,
    // speech_recognition,
  },
})
